<template>
  <loader v-if="dataLoading" />
  
  <div class="page">

    <div class="flex justify-content-center">
      <div class="grid">
        <div class="grid">
          <div class="col p-as-end">
            <i></i><br>
            <span class="p-input-icon-left">
              <i class="pi pi-filter" />
              <input-number 
                v-model="filter" 
                showButtons buttonLayout="horizontal" 
                inputStyle="text-align:center;"
                
                :step="1"
                decrementButtonClass="p-button-danger" 
                incrementButtonClass="p-button-success" 
                
                incrementButtonIcon="pi pi-plus" 
                decrementButtonIcon="pi pi-minus"

                :useGrouping="false"
              />
            </span>
          </div>
        </div>
      </div>
    </div>

    <data-table :value="data.stats" dataKey="start_date" responsiveLayout="scroll" >
      <column field="start_date" header="Mese">
        <template #body="{data}">
          {{ (data.start_date !== null)? moment(data.start_date).locale('it').format('MMMM YYYY').toUpperCase(): '' }}
        </template>
      </column>
      <column field="fatturate" header="Fatture"></column>
      <column field="emesse" header="Fatture Emesse"></column>
      <column field="scartate" header="Fatture Scartate"></column>
      <column field="non_emesse" header="Fatture Non Emesse"></column>
      <column field="fatture_vuote" header="Fatture Vuote"></column>
      <column field="assenti_agyo" header="Assenti Agyo">
        <template #body="{data}">
          <prime-button
            v-if="Number(data.assenti_agyo) > 0"
            :label="String(data.assenti_agyo)"
            class="p-button-sm p-button-outlined p-button-warning"
            @click="openAssentiDialog(data)"
          />
          <span v-else>0</span>
        </template>
      </column>
      <column :exportable="false">
        <template #body="{data}">
          <prime-button 
            icon="pi pi-download" 
            class="p-button-rounded p-button-success mr-2" 
            @click="onDownloadCsv(data.start_date)" 
          />
          <prime-button
            icon="pi pi-eye"
            class="p-button-rounded p-button-info"
            @click="openScartateDialog(data)"
          />
        </template>
      </column>
    </data-table>

    <Dialog
      :visible="dialogScartate.visible"
      :style="{ width: '40vw' }"
      modal
      header="Fatture Scartate"
      @update:visible="onDialogVisibilityChange"
    >
      <loader v-if="dialogScartate.loading" />
      <div v-else>
        <data-table
          v-if="dialogScartate.items.length"
          :value="dialogScartate.items"
          responsiveLayout="scroll"
        >
          <column
            v-for="field in scartateFields"
            :key="field"
            :field="field"
            :header="formatHeader(field)"
          >
            <template #body="{data}">
              <div v-if="field === 'Fatture'">
                <div v-if="Array.isArray(data[field]) && data[field].length" class="fatture-list">
                  <div v-for="(fattura, index) in data[field]" :key="`${fattura.numero}-${index}`" class="fattura-item">
                    <div class="fattura-row">
                      <div class="fattura-content">
                        <span class="fattura-numero">{{ fattura.numero }}</span>
                        <span v-if="fattura.motivazione" class="fattura-motivazione"> - {{ fattura.motivazione }}</span>
                      </div>
                      <prime-button
                        label="Riemetti"
                        class="p-button-sm p-button-warning"
                        :loading="isRiemettiLoading(fattura.numero)"
                        @click="confirmRiemettiFattura(fattura, data)"
                      />
                    </div>
                  </div>
                </div>
                <span v-else>-</span>
              </div>
              <span v-else>{{ formatValue(data[field]) }}</span>
            </template>
          </column>
        </data-table>
        <p v-else class="m-0">Nessuna fattura scartata per il periodo selezionato.</p>
      </div>
    </Dialog>

    <Dialog
      :visible="dialogAssenti.visible"
      :style="{ width: '32vw' }"
      modal
      :header="dialogAssenti.header"
      @update:visible="onAssentiDialogVisibilityChange"
    >
      <loader v-if="dialogAssenti.loading" />
      <div v-else>
        <div v-if="dialogAssenti.numeri.length" class="assenti-toolbar">
          <span>{{ dialogAssenti.numeri.length }} fatture</span>
          <prime-button
            label="Copia numeri"
            class="p-button-sm p-button-outlined"
            @click="copyAssentiNumeri"
          />
        </div>
        <data-table
          v-if="dialogAssenti.numeri.length"
          :value="dialogAssentiRows"
          responsiveLayout="scroll"
          scrollable
          scrollHeight="360px"
        >
          <column field="numero" header="Numero"></column>
        </data-table>
        <p v-else class="m-0">Nessuna fattura assente su Agyo per il periodo selezionato.</p>
      </div>
    </Dialog>
    
  </div>
</template>

<script>
import moment from 'moment'

import Service from '@/services/ask-management/utility-agyo-service'

import Loader from '@/components/Loader.vue'
import PrimeButton from 'primevue/button'
import Dialog from 'primevue/dialog'

export default { 
  components: {
    Loader,
    PrimeButton,
    Dialog,
  },

  data() {
    return {
      moment,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      dataLoading: false,
      filter: new Date().getFullYear(),
      dialogScartate: {
        visible: false,
        loading: false,
        date: null,
        items: [],
      },
      dialogAssenti: {
        visible: false,
        loading: false,
        date: null,
        header: 'Assenti Agyo',
        numeri: [],
      },
      scartateByYear: [],
      scartateLoadedYear: null,
      riemettiLoading: {},

      data: {
        stats: []
      },
    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)
    this.getStatistiche()
  },

  methods:{

    onDownloadCsv(date){
      this.service.downloadFileCsv(date)
    },

    async openScartateDialog(row){
      this.dialogScartate.visible = true
      this.dialogScartate.loading = true
      this.dialogScartate.date = row.start_date

      try {
        if (!this.scartateByYear.length || this.filter !== this.scartateLoadedYear) {
          this.scartateByYear = await this.service.getScartateByYear(this.filter)
          this.scartateLoadedYear = this.filter
        }

        const selectedMonth = this.scartateByYear.find((item) => item.Inizio === row.start_date)
        this.dialogScartate.items = selectedMonth ? [selectedMonth] : []
      } finally {
        this.dialogScartate.loading = false
      }
    },

    confirmRiemettiFattura(fattura, monthData){
      const numero = String(fattura?.numero || '').trim()
      if (!numero) {
        return
      }

      if (this.$confirm?.require) {
        this.$confirm.require({
          message: `Vuoi riemettere la fattura ${numero}?`,
          header: 'Conferma',
          icon: 'pi pi-info-circle',
          acceptLabel: 'Si',
          rejectLabel: 'No',
          accept: () => {
            this.riemettiFattura(numero, monthData)
          },
        })
        return
      }

      const confirmed = window.confirm(`Vuoi riemettere la fattura ${numero}?`)
      if (confirmed) {
        this.riemettiFattura(numero, monthData)
      }
    },

    async riemettiFattura(numero, monthData){
      this.riemettiLoading = {
        ...this.riemettiLoading,
        [numero]: true,
      }

      try {
        const res = await this.service.resetScartateByNumeri([numero])
        if (!res) {
          return
        }

        const list = Array.isArray(monthData.Fatture) ? monthData.Fatture : []
        monthData.Fatture = list.filter((item) => item.numero !== numero)
        monthData.Scartate = Math.max(0, Number(monthData.Scartate || 0) - 1)

        const statsRow = this.data.stats.find((item) => item.start_date === monthData.Inizio)
        if (statsRow) {
          statsRow.scartate = Math.max(0, Number(statsRow.scartate || 0) - 1)
        }
      } finally {
        this.riemettiLoading = {
          ...this.riemettiLoading,
          [numero]: false,
        }
      }
    },

    isRiemettiLoading(numero){
      return !!this.riemettiLoading[numero]
    },

    onDialogVisibilityChange(value){
      this.dialogScartate.visible = value
      if (!value) {
        this.dialogScartate.items = []
        this.dialogScartate.date = null
        this.riemettiLoading = {}
      }
    },

    async openAssentiDialog(row){
      this.dialogAssenti.visible = true
      this.dialogAssenti.loading = true
      this.dialogAssenti.date = row.start_date
      this.dialogAssenti.header = `Assenti Agyo - ${moment(row.start_date).locale('it').format('MMMM YYYY')}`
      this.dialogAssenti.numeri = []

      try {
        const res = await this.service.getAssentiAgyoByMonth(row.start_date)
        this.dialogAssenti.numeri = Array.isArray(res?.numeri) ? res.numeri : []
      } finally {
        this.dialogAssenti.loading = false
      }
    },

    onAssentiDialogVisibilityChange(value){
      this.dialogAssenti.visible = value
      if (!value) {
        this.dialogAssenti.numeri = []
        this.dialogAssenti.date = null
      }
    },

    copyAssentiNumeri(){
      const text = this.dialogAssenti.numeri.join('\n')
      if (!text) {
        return
      }

      if (navigator?.clipboard?.writeText) {
        navigator.clipboard.writeText(text)
        return
      }

      window.prompt('Copia i numeri', text)
    },

    formatHeader(field){
      return field
        .replaceAll('_', ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase())
    },

    formatValue(value){
      if (value === null || value === undefined || value === '') {
        return '-'
      }

      if (typeof value === 'object') {
        return JSON.stringify(value)
      }

      return value
    },

    /////

    navigateToTab(href){
      window.open(href, '_blank')
    },

    applyFilter(filter){
      const length = filter.toString().length
      if(length == 4){
        this.getStatistiche()
      }
    },

    getStatistiche(){
      this.dataLoading = true
      this.scartateByYear = []
      this.scartateLoadedYear = null

      this.service.getStatisticheByYear(this.filter).then((res) => {
        this.data.stats = res.items
      }).finally(() =>{
        this.dataLoading = false
      })
    }

  },

  computed:{
    scartateFields() {
      return ['Inizio', 'Fine', 'Scartate','Fatture']
    },
    dialogAssentiRows() {
      return this.dialogAssenti.numeri.map((numero) => ({ numero }))
    },
  },

  watch: {
    filter(newVal) {
      this.applyFilter(newVal)
    },
  },
}
</script>

<style scoped>
.box-center{
  text-align: center;
}

.fattura-item {
  margin-bottom: 0.35rem;
  padding: 0.35rem 0.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
}

.fatture-list {
  max-height: 320px;
  overflow-y: auto;
  padding-right: 0.25rem;
}

.fattura-item:last-child {
  margin-bottom: 0;
}

.fattura-numero {
  font-weight: 600;
}

.fattura-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;
}

.fattura-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.75rem;
}

.fattura-row :deep(.p-button) {
  white-space: nowrap;
}

.assenti-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}
</style>
